
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { resolveSubject } from '../../canvas/commands/CommandUtil';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { Comment } from './Comment';
import { Commentable } from './Commentable';
import { CommentWidget } from './CommentWidget';

export const commentsAdd = defineCommand(
    'commentsAdd',
    'Comments: Add',
    (r, [targetId, body]: [string, string]) => {

        const objects = r.call(ObjectManager);

        const subject = resolveSubject(r, targetId, Commentable);
        if (!subject) return false;

        const newId = objects.update(u => {
            const comm = u.create(Comment);
            comm.content = body || '';
            subject.add(comm);

            u.set('key', `comment:${comm.id}`);
            return comm.id;
        });

        r.call(CommandDispatcher)(commentsOpen, [subject.id, true]);

        return newId;
    }
);

export const commentsDelete = defineCommand(
    'commentsDelete',
    null,
    (r, [targetId]: [string]) => {

        const objects = r.call(ObjectManager);
        const subject = objects.getMaybe(targetId, Comment);
        if (!subject) return false;

        objects.update(u => {
            u.set('key', `comment:${subject.id}`);
            u.delete(subject.removeSelf(), 'cascade');
        });
    }
);

export const commentsOpen = defineCommand(
    'comments',
    'Comments: Open',
    (r, [targetId, toWrite]: [string?, boolean?]) => {
        toWrite = !!toWrite;

        const widgets = r.call(WidgetManager);
        const subject = resolveSubject(r, targetId, Commentable);
        if (!subject) return false;

        widgets.delete('comments');

        const cont = widgets.createContainer({
            name: 'comments',
            position: ['attached', { to: subject.id, placement: 'right-end', offset: [1, 2], zOrder: 111 }],
            direction: 'row',
            style: 'none',
        });

        cont.add(widgets.createInline({ ui: CommentWidget, subject, autoFocus: toWrite }));
        widgets.add(cont);
        return true;
    }
);

export const commentsClose = defineCommand(
    'comments',
    'Comments: Close',
    r => {
        const widgets = r.call(WidgetManager);
        widgets.delete('comments');
        return true;
    }
);

export const inCommentCommands = () => inCommands(
    commentsAdd,
    commentsOpen,
);

